import React, {
  useRef,
  useState,
  useCallback,
  Dispatch,
  SetStateAction,
} from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  Button as MaterialButton,
} from '@material-ui/core';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useToast } from '../../../../hooks/toast';
import Input from '../../../Input';
import api from '../../../../services/api';
import { Montagem } from '..';

// import { Container } from './styles';
interface DialogProps {
  openCadastroMontagem: boolean;
  setOpenCadastroMontagem: Dispatch<SetStateAction<boolean>>;
  setAddMontagem: Dispatch<SetStateAction<boolean>>;
  montagens: Montagem[];
  setMontagens: Dispatch<SetStateAction<Montagem[]>>;
}
const DialogCadastroMontagem: React.FC<DialogProps> = ({
  openCadastroMontagem,
  setOpenCadastroMontagem,
  montagens,
  setMontagens,
  setAddMontagem,
}) => {
  const [disabled, setDisabled] = useState(false);
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);

  const handleCloseCadastro = useCallback(() => {
    setOpenCadastroMontagem(false);
  }, [setOpenCadastroMontagem]);
  const handleSubmitCadastroMontagem = useCallback(
    async ({ nm }) => {
      const teste: number[] = montagens.map((mont) => mont.ordem);
      const mont: Montagem = {
        focus: true,
        nm,
        ordem: Math.max(...teste) + 1,
      } as Montagem;
      setMontagens([
        ...montagens.map((montagem) => {
          // eslint-disable-next-line no-param-reassign
          montagem.focus = false;
          return montagem;
        }),
        mont,
      ]);
      handleCloseCadastro();
      setAddMontagem(true);
    },
    [handleCloseCadastro, montagens, setAddMontagem, setMontagens],
  );
  return (
    <Dialog
      open={openCadastroMontagem}
      onClose={handleCloseCadastro}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Cadastrar Montagem</DialogTitle>
      <Form ref={formRef} onSubmit={handleSubmitCadastroMontagem}>
        <DialogContent>
          <InputLabel
            id="select-label"
            style={{ marginBottom: '4px', marginLeft: '2px' }}
          >
            Nome:
          </InputLabel>
          <Input name="nm" placeholder="Nome" defaultValue="" autoFocus />
        </DialogContent>
        <DialogActions>
          <MaterialButton
            onClick={handleCloseCadastro}
            style={{
              color: '#2c73e9',
            }}
          >
            Cancelar
          </MaterialButton>
          <MaterialButton
            type="submit"
            disabled={disabled}
            style={{
              color: '#2c73e9',
            }}
          >
            Cadastrar
          </MaterialButton>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default DialogCadastroMontagem;
